import WeddingInvite from './WeddingInvite';

function App() {
  return <WeddingInvite />;
}

export default App;
